import React from 'react';
import { useFormContext } from 'react-hook-form';

import * as styled from './styles';

type Option = { value: string; label: string };

type Props = {
  name: string;
  label?: string;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
};

export const FormSelect = ({
  name,
  label,
  options,
  placeholder,
  disabled,
}: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message as string | undefined;

  return (
    <styled.Field>
      {label && <styled.Label>{label}</styled.Label>}
      <styled.Select
        {...register(name)}
        $hasError={!!error}
        $disabled={disabled}
        aria-invalid={!!error}
        disabled={disabled}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </styled.Select>
      {error && <styled.ErrorText>{error}</styled.ErrorText>}
    </styled.Field>
  );
};
